export function normalizeMeetingUrlInput(raw) {
  const s = String(raw || '').trim();
  if (!s) return '';
  if (/^https?:\/\//i.test(s)) return s;
  return `https://${s}`;
}

export function hasMeetingUrl(raw) {
  return Boolean(normalizeMeetingUrlInput(raw));
}
